import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';

/**
 * Get list of Sales Returns with pagination/filtering
 */
export const getSalesReturns = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/sales-returns', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * Fetch a single Sales Return for viewing
 */
export const fetchSalesReturn = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/sales-returns/${id}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * Create a new Sales Return
 */
export const createSalesReturn = async (newData, callback) => {
    try {
        const response = await risapi.post('/api/sales-returns', newData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data);
        }
    } catch (error) {
        // Pass full error back to form for handling 422s etc.
        callback({ error }); 
    }
};

/**
 * Fetch invoices for a specific party to populate the dropdown.
 * Assumes your SalesInvoiceController accepts a 'party_id' filter.
 */
export const getInvoicesForReturn = async (partyId, callback) => {
    try {
        // Using 'nopaginate=true' to get a simple list for the dropdown
        const response = await risapi.get(`/api/sales-invoices?party_id=${partyId}&nopaginate=true`, getAxiosConfig());
        if (response.status === 200) {
             // Handle different possible response structures (paginated vs non-paginated)
             const data = response.data.sales_invoices?.data || response.data.sales_invoices || [];
             callback(data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * Get returnable items for a specific invoice to pre-populate the form.
 */
export const getSalesReturnPrepopulation = async (invoiceId, callback) => {
    try {
        const response = await risapi.get(`/api/sales-returns/create?source_invoice_id=${invoiceId}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        // Pass error back for specific UI handling (e.g. "Invoice fully returned")
        callback({ error: error.response?.data || { message: 'Error fetching invoice details.' } });
    }
};